import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/80 backdrop-blur-md border-b border-white/10' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/aa6abdeba4fcc892fbf2695715834049.png" 
              alt="Tehk Zone" 
              className="h-10 sm:h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('showcase')}
              className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Core Values
            </button>
            <Link 
              to="/services"
              className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Services
            </Link>
            <Link 
              to="/about"
              className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              About
            </Link>
            <Link 
              to="/who-we-are"
              className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Who We Are
            </Link>
            <Link 
              to="/contact"
              className="px-6 py-2 bg-gradient-to-r from-violet-500 to-purple-500 text-white text-sm rounded-lg hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2 cursor-pointer"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <i className="ri-close-line text-2xl"></i>
            ) : (
              <i className="ri-menu-line text-2xl"></i>
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-white/10">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('showcase')}
                className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer text-left"
              >
                Core Values
              </button>
              <Link 
                to="/services"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
              >
                Services
              </Link>
              <Link 
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
              >
                About
              </Link>
              <Link 
                to="/who-we-are"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
              >
                Who We Are
              </Link>
              <Link 
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-6 py-2 bg-gradient-to-r from-violet-500 to-purple-500 text-white text-sm rounded-lg hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Contact Us
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
